'use client';

import { noBorderStyles, PRESET_AMOUNTS } from '@/src/constants/constants';
import { Input } from '@workspace/ui/components/input';

type Props = {
  selectedAmount: number;
  customAmount: string;
  onPresetClick: (value: number) => void;
  onCustomAmountChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const AmountUsdSelection = ({
  selectedAmount,
  customAmount,
  onPresetClick,
  onCustomAmountChange,
}: Props) => {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-3 gap-2">
        {PRESET_AMOUNTS.map((presetAmount) => (
          <button
            key={presetAmount}
            onClick={() => onPresetClick(presetAmount)}
            className={`p-4 rounded-xl border-2 transition-all duration-300 hover:cursor-pointer hover:border-blue-primary ${
              selectedAmount === presetAmount
                ? 'border-blue-primary text-black bg-white'
                : 'bg-bg-gray border-transparent text-black/40'
            }`}
          >
            <div className="flex items-center justify-center text-lg font-medium">
              <div className="w-fit font-medium relative">
                <span
                  className={`text-xs font-light absolute ${
                    selectedAmount === presetAmount ? 'top-1.5' : '-top-0.5'
                  } -left-3`}
                >
                  $
                </span>
                {presetAmount}
              </div>
            </div>
          </button>
        ))}
      </div>

      <div className="space-y-2">
        <label htmlFor="custom-amount" className="relative">
          <span
            className={`text-xs font-light absolute top-5 ${
              customAmount ? 'flex' : 'hidden'
            } left-3`}
          >
            $
          </span>
          <Input
            id="custom-amount"
            placeholder="Enter custom amount"
            style={noBorderStyles}
            value={customAmount}
            onChange={onCustomAmountChange}
            className="md:text-lg p-4 bg-bg-gray h-16 rounded-xl placeholder:text-black/40 placeholder:text-sm pl-6"
            type="text"
          />
          {customAmount && parseInt(customAmount) < 1 && (
            <p className="text-sm text-red-500">Minimum amount is $1</p>
          )}
        </label>
      </div>
    </div>
  );
};
